// // ========================================================================
// // 🧠 Shopify + Make.com Integration
// // Versione ottimizzata per FoxTheme / Sleek
// // ========================================================================
// // ✅ COSA FA:
// //      1. Intercetta i form con attributo [data-make-webhook]
// //      2. Invia i dati al webhook di Make.com
// //      3. Dopo l’invio, lascia che Shopify gestisca il form normalmente
// //
// // ⚙️ ISTRUZIONI:
// //      1. Crea un Webhook su Make.com → Tools → Webhooks → Custom Webhook
// //      2. Copia l’URL e incollalo qui sotto in `WEBHOOK_URL`
// //      3. Carica questo file nella cartella "Assets" del tema
// //      4. Includilo nel theme.liquid PRIMA del tag </body>:
// //      5. Nei tuoi form Liquid aggiungi l’attributo: data-make-webhook
// //      Esempio: <form id="ContactForm" data-make-webhook>
// // ========================================================================

// (() => {
//     // ===========================================================
//     // ⚙️ CONFIGURAZIONE PRINCIPALE
//     // ===========================================================
//     const CONFIG = {
//         WEBHOOK_URL: 'https://hook.eu2.make.com/m7yx8bxh5ugobr3i9gl6e1gv8oir52wa',
//         DEBUG: true, // imposta a false per nascondere i log in produzione
//     };

//     // ===========================================================
//     // 🧩 FUNZIONI UTILI
//     // ===========================================================

//     /**
//      * Controlla se il webhook è stato configurato correttamente
//      */
//     function isWebhookConfigured() {
//         return CONFIG.WEBHOOK_URL && CONFIG.WEBHOOK_URL !== '';
//     }

//     /**
//     *   Log semplificato per debug (disattivabile da CONFIG.DEBUG)
//     */
//     function log(message, type = 'info') {
//         if (!CONFIG.DEBUG) return;

//         const prefix = '📡 [Make.com Integration]';
//         switch (type) {
//         case 'error':
//             console.error(`${prefix} ❌ ${message}`);
//             break;
//         case 'warn':
//             console.warn(`${prefix} ⚠️ ${message}`);
//             break;
//         default:
//             console.log(`${prefix} ${message}`);
//         }
//     }

//     /**
//     *   Invia i dati del form a Make.com via webhook
//     */
//     async function sendToMake(formData) {
//         if (!isWebhookConfigured()) {
//             log('⚠️ Webhook non configurato. Skip invio a Make.com', 'warn');
//             return;
//         }

//         // 🔍 Debug: mostra il contenuto del FormData prima dell’invio
//         console.group('🧾 FormData inviato a Make.com');
//         for (const [key, value] of formData.entries()) {
//             console.log(`${key}:`, value);
//         }
//         console.groupEnd();

//         try {
//             const response = await fetch(CONFIG.WEBHOOK_URL, {
//                 method: 'POST',
//                 body: formData,
//             });
//             if (response.ok) {
//                 setTimeout(() => {
//                     log('✅ Dati inviati correttamente a Make.com');
//                 }, 5000);
//             } else {
//                 log(`❌ Errore Make.com: ${response.status} ${response.statusText}`, 'error');
//             }
//         } catch (error) {
//             log(`🚨 Errore di rete durante la chiamata a Make.com: ${error}`, 'error');
//         }
//     }

//     /**
//      * Logga ogni input compilato in tempo reale
//      */
//     document.addEventListener('input', (e) => {
//         const input = e.target;
//         if (input.form && input.form.matches('[data-make-webhook]')) {
//             console.log(`✏️ Campo modificato: ${input.name} = ${input.value}`);
//         }
//     });

//     /**
//     *   Gestisce il submit del form
//     */
//     async function handleFormSubmit(event) {
//         const form = event.target;

//         // Rispetta la validazione HTML
//         if (!form.checkValidity()) return;

//         // Interrompe l’invio nativo per il tempo del fetch
//         event.preventDefault();

//         const formData = new FormData(form);
//         log(`Invio dati al webhook di Make.com (${form.id || 'senza ID'})...`);

//         await sendToMake(formData);

//         // Poi procedi con l’invio nativo a Shopify
//         log('📨 Invio del form a Shopify...');
//         form.requestSubmit();
//     }

//     /**
//     *   Inizializza la connessione per tutti i form con [data-make-webhook]
//     */
//     function initMakeIntegration() {
//         const forms = document.querySelectorAll('form[data-make-webhook]');
//         if (!forms.length) {
//             log('Nessun form con [data-make-webhook] trovato.', 'warn');
//             return;
//         }

//         forms.forEach((form) => {
//             if (form.dataset.makeWebhookBound === 'true') return;

//             form.dataset.makeWebhookBound = 'true';
//             form.addEventListener('submit', handleFormSubmit);

//             log(`Listener attivo su form: #${form.id || 'senza ID'}`);
//         });
//     }

//     // ===========================================================
//     // 🚀 INIZIALIZZAZIONE
//     // ===========================================================

//     if (!isWebhookConfigured()) {
//         log('⚠️ Webhook Make.com non configurato o placeholder rilevato.', 'warn');
//     } else {
//         log('Webhook Make.com configurato correttamente.');
//     }

//     document.addEventListener('DOMContentLoaded', initMakeIntegration);
//     document.addEventListener('shopify:section:load', initMakeIntegration);
// })();

(() => {
    const CONFIG = {
        WEBHOOK_URL: 'https://hook.eu2.make.com/m7yx8bxh5ugobr3i9gl6e1gv8oir52wa',
        DEBUG: true,
    };

    function isWebhookConfigured() {
        return CONFIG.WEBHOOK_URL && CONFIG.WEBHOOK_URL !== '';
    }

    function log(message, type = 'info') {
        if (!CONFIG.DEBUG) return;
        const prefix = '📡 [Make.com Integration]';
        const fn =
            type === 'error' ? console.error :
            type === 'warn' ? console.warn :
            console.log;
        fn(`${prefix} ${message}`);
    }

    async function sendToMake(formData) {
        if (!isWebhookConfigured()) {
            log('⚠️ Webhook non configurato. Skip invio a Make.com', 'warn');
            return;
        }

        console.groupCollapsed('🧾 FormData inviato a Make.com');
        for (const [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }
        console.groupEnd();

        try {
            const response = await fetch(CONFIG.WEBHOOK_URL, {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                setTimeout(() => {
                    log('✅ Dati inviati correttamente a Make.com');
                }, 1000);
            } else {
                log(`❌ Errore Make.com: ${response.status} ${response.statusText}`, 'error');
            }
        } catch (error) {
            log(`🚨 Errore di rete durante la chiamata a Make.com: ${error}`, 'error');
        }
    }

    async function handleFormSubmit(event) {
        const form = event.target;

        // Blocca doppi invii rapidi
        if (form.dataset.makeSubmitted === 'true') {
            log(`⏸️ Invio già in corso per il form ${form.id || ''}. Ignorato.`, 'warn');
            return;
        }

        if (!form.checkValidity()) return;

        event.preventDefault();
        form.dataset.makeSubmitted = 'true';

        const formData = new FormData(form);
        log(`Invio dati al webhook di Make.com (${form.id || 'senza ID'})...`);

        await sendToMake(formData);

        // Invia a Shopify senza rilanciare l’evento submit
        HTMLFormElement.prototype.submit.call(form);
    }

    function initMakeIntegration() {
        const forms = document.querySelectorAll('form[data-make-webhook]');
        if (!forms.length) {
            log('Nessun form con [data-make-webhook] trovato.', 'warn');
            return;
        }

        forms.forEach((form) => {
            if (form.dataset.makeWebhookBound === 'true') return;

            form.dataset.makeWebhookBound = 'true';
            form.addEventListener('submit', handleFormSubmit);

            log(`Listener attivo su form: #${form.id || 'senza ID'}`);
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (!isWebhookConfigured()) {
            log('⚠️ Webhook Make.com non configurato o placeholder rilevato.', 'warn');
        } else {
            log('✅ Webhook Make.com configurato correttamente.');
        }
        initMakeIntegration();
    });

    document.addEventListener('shopify:section:load', initMakeIntegration);
})();
